// extracted by mini-css-extract-plugin
module.exports = {"Main":"about_Main__AH1A0","MainInfo":"about_MainInfo__8R8PC","MainLogo":"about_MainLogo__FMQTV"};